export enum DenialRationalTemplateListActionDispatchTypes {
  POST_DENIAL_RATIONALE_TEMPLATE_LIST_INVOKE = "POST_DENIAL_RATIONALE_TEMPLATE_LIST_INVOKE",
  POST_DENIAL_RATIONALE_TEMPLATE_LIST_SUCCESS = "POST_DENIAL_RATIONALE_TEMPLATE_LIST_SUCCESS",
  POST_DENIAL_RATIONALE_TEMPLATE_LIST_ERROR = "POST_DENIAL_RATIONALE_TEMPLATE_LIST_ERROR",
}

export enum RationaleManagementTemplateNameActionDispatchTypes {
  GET_RATIONALE_MANAGEMENT_TEMPLATE_NAME_INVOKE = "GET_RATIONALE_MANAGEMENT_TEMPLATE_NAME_INVOKE",
  GET_RATIONALE_MANAGEMENT_TEMPLATE_NAME_SUCCESS = "GET_RATIONALE_MANAGEMENT_TEMPLATE_NAME_SUCCESS",
  GET_RATIONALE_MANAGEMENT_TEMPLATE_NAME_ERROR = "GET_RATIONALE_MANAGEMENT_TEMPLATE_NAME_ERROR",
}

export const HeaderLabel = [
  { label: "TEMPLATE NAME", style: { width: "42%" } },
  { label: "AUTH TYPE", style: { width: "14%" } },
  { label: "DENIAL TYPE", style: { width: "14%" } },
  { label: "DISCIPLINE", style: { width: "10%" } },
  { label: "STATUS", style: { width: "10%" } },
  { label: "", style: { width: "10%" } },
];
